import { Validator } from '../../../utils/validators/types';

export const utmParamsValidator =
    (message: string): Validator<string> =>
    (value?: string) => {
        if (!value) {
            return;
        }

        const invalidParams: string[] = [];
        const params = value?.split('&');

        params.forEach((paramStr) => {
            if (!paramStr) {
                return;
            }

            const param = paramStr.split('=');
            const name = param[0];
            const keyword = param[1];

            if (!name || param.length > 2 || (param.length === 2 && !keyword)) {
                invalidParams.push(paramStr);
            }
        });

        if (invalidParams.length) {
            return `${message}: ${invalidParams.join('&')}`;
        }
    };
